import Controller from '../abstracts/Controller';
import 'scss-templates/t-login.scss';

export default class LoginController extends Controller {
  static get COMPONENTS() {
    return [
    ];
  }

  init() {
    super.init();

    /* LOGIN PAGE */
    const emailInput = document.querySelector('#j_username');
    const pwdInput = document.querySelector('#j_password');
    const submitButton = document.querySelector('#j_submit');

    emailInput.addEventListener('input', () => {
      if (emailInput.value && emailInput.value != '' && pwdInput.value && pwdInput.value != '') {
        submitButton.classList.remove('disabled');
        submitButton.removeAttribute('disabled');
      } else {
        submitButton.classList.add('disabled');
        submitButton.setAttribute('disabled', 'disabled');
      }
    })

    pwdInput.addEventListener('input', () => {
      if (emailInput.value && emailInput.value != '' && pwdInput.value && pwdInput.value != '') {
        submitButton.classList.remove('disabled');
        submitButton.removeAttribute('disabled');
      } else {
        submitButton.classList.add('disabled');
        submitButton.setAttribute('disabled', 'disabled');
      }
    })

    /* MINI MYACCOUNT MODAL */
    const emailInputMini = document.querySelector('#m_username');
    const pwdInputMini = document.querySelector('#m_password');
    const submitButtonMini = document.querySelector('#m_submit');
    console.log({emailInputMini})
    console.log({pwdInputMini})
    console.log({submitButtonMini})

    emailInputMini.addEventListener('input', () => {
      if (emailInputMini.value && emailInputMini.value != '' && pwdInputMini.value && pwdInputMini.value != '') {
        submitButtonMini.classList.remove('disabled');
        submitButtonMini.removeAttribute('disabled');
      } else {
        submitButtonMini.classList.add('disabled');
        submitButtonMini.setAttribute('disabled', 'disabled');
      }
    })

    pwdInputMini.addEventListener('input', () => {
      if (emailInputMini.value && emailInputMini.value != '' && pwdInputMini.value && pwdInputMini.value != '') {
        submitButtonMini.classList.remove('disabled');
        submitButtonMini.removeAttribute('disabled');
      } else {
        submitButtonMini.classList.add('disabled');
        submitButtonMini.setAttribute('disabled', 'disabled');
      }
    })
  }
}
